import SDG from './SDG';

export default SDG;



// WEBPACK FOOTER //
// ./src/components/SustainableDevGoals/index.js